// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-k_fE","catalogByServiceItem__title":"c-k_fF"};